import React from 'react'
import { Box } from '@material-ui/core'
import Spinner from 'src/components/Spinner'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'

const PostGraduateSubscriptionLoading = () => {
  const globalClasses = useGlobalStyles()

  return (
    <Box className={globalClasses.containerPages}>
      <Box className={globalClasses.topPageBreadcrumbsSearch}>
        <BreadcrumbsComponent
          crumbs={[
            { label: 'Home', path: '/news/home' },
            { label: 'Pós-Graduação', path: '/postgraduate' },
            { label: 'Inscrição' }
          ]}
        />
      </Box>
      <Spinner />
    </Box>
  )
}

export default PostGraduateSubscriptionLoading
